<!-- 请假管理 -->
<template>
  <div class="fuzzy-matching-box">
    <!-- 请假管理 -->
    <div class="fuzzy-matching-top">
      <el-row class="top-first-line the-second-line">
        <el-col :span="4">
          <el-form-item label="姓名:">
            <el-input v-model="Dform.studentName" placeholder=''></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="学号:">
            <el-input v-model="Dform.studentNo" placeholder=''></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item label="imei:">
            <el-input v-model="Dform.imei" placeholder=''></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="开始时间：">
            <el-date-picker v-model="Dform.startTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
                            value-format="YYYY-MM-DDTHH:mm:ss" placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="结束时间：">
            <el-date-picker v-model="Dform.endTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
                            value-format="YYYY-MM-DDTHH:mm:ss" placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="top-first-line the-second-line">
        <el-col :span="4">
          <el-form-item label="学校:">
            <!-- <el-input v-model="Dform.schoolName" placeholder=''></el-input> -->
            <el-select v-model="schoolListTopId" placeholder="请选择学校" @change="schoolClickTop"
                       @click="schoolPost(true)">
              <el-option :label="item.name" :value="item.id" v-for="item in schoolListTop"
                         :key="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="年级:">
            <!-- <el-input v-model="Dform.gradeName" placeholder=''></el-input> -->
            <el-select v-model="gradeDataListTopId" placeholder="请选择年级" @change="gradeClickTop"
                       @click="gradePost()">
              <el-option :label="item.name" :value="item.id" v-for="item in gradeDataListTop"
                         :key="item.name"></el-option>
            </el-select>
            <!-- <div class="loading_view" v-if="grade_loading"><text>加载中...</text></div> -->
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="班级:">
            <!-- <el-input v-model="Dform.className" placeholder=''></el-input> -->
            <el-select v-model="classListTopId" placeholder="请选择班级" @change="classClickTop" @click="classPost()">
              <el-option :label="item.name" :value="item.id" v-for="item in classListTop"
                         :key="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
<!--        <el-col :span="4">-->
<!--          <el-form-item label="状态：">-->
<!--            <el-select v-model="leaveType" filterable placeholder="请选择请假状态" @change="leaveTypeclick">-->
<!--              <el-option v-for="item in options" :key="item.value" :label="item.label"-->
<!--                         :value="item.value">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="5">
          <el-button type="primary" size="medium" class="right query-button" plain
                     @click="filtrateclick">导出筛选数据</el-button>
          <el-button type="primary" size="medium" class="query-button" @click="entrylogClick">查询</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="top-first-line the-second-line the-second-line">
      <div class="status-tabs">
        <!-- 状态切换标签 -->
        <div
            v-for="item in statusList"
            :key="item.key"
            class="status-tab-item"
            :class="{ active: leaveType === item.key }"
            @click="handleTabChange(item.key)"
        >
          {{ item.label }}
        </div>
      </div>

    </div>
    <div class="fuzzy-matching-bottom">
      <el-row class="list">
        <el-table stripe :border="true" v-loading="loading"
                  :header-cell-style="{ background: '#EDF6FF', color: '#000', }" ref="multipleTable" :data="tableData"
                  tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column prop="stuName" label="学生姓名" width="130">
          </el-table-column>
          <el-table-column prop="stuNum" label='学生学号' width="170">
          </el-table-column>
          <el-table-column label="类型" width="70">
            <template #default="scope">
              <span v-if="scope.row.type == 1">{{ '病假' }}</span>
              <span v-if="scope.row.type == 2">{{ '事假' }}</span>
              <span v-if="scope.row.type == 3">{{ '其他' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="90">
            <template #default="scope">
              <span style="color: #ffc300" v-if="scope.row.status == 0">待审批</span>
              <span style="color: #00aa00" v-if="scope.row.status == 1">已同意</span>
              <span style="color: red" v-if="scope.row.status == 2">已拒绝</span>
            </template>
          </el-table-column>
          <el-table-column prop="reason" label="请假原因" min-width="200" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="startDate" label="请假开始时间" width="230" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="endDate" label="请假结束时间" width="230" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="time" label="请假时长(小时)" width="170">
          </el-table-column>
          <el-table-column prop="cancelDate" label="销假时间" width="230" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="createDate" label="申请时间" width="230" show-overflow-tooltip>
          </el-table-column>

        </el-table>

        <div class="block">
          <div class="total"> 共<span class="texttiao">{{total}}</span>条记录，当前显示<span
              class="texttiao">{{ twigMin }}</span>到<span class="texttiao">{{ twigMax }}</span>条</div>

          <el-pagination :small="small" :disabled="disabled" :background="background"
                         layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
                         @current-change="handleCurrentChange" />
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  schoolOrUserManagementleavePage,
  schoolOrUserManagementList
} from '@/assets/api/schoollog';
import {
  studentDaoChuInfo,
  schoolList,
  gradeList,
  findClassList, exportLeaveData
} from '@/assets/api/renyuan';
import {
  ElMessage,
  ElLoading
} from 'element-plus'
import {
  UserFilled
} from "@element-plus/icons-vue"; // 图标

export default {
  components: {
    UserFilled
  },
  data() {
    return {
      daochuValue: false,
      loading: true,
      ShowPeople: false,
      Dform: {
        className: "",
        gradeName: "",
        schoolName: "",
        rfid: "",
        studentName: "",
        studentNo: "",
        imei: '',
        leaveType: '',
        startTime: '',
        endTime: '',
      },
      tableData: [],
      total: "",
      pageInfo: {
        pageSize: 10,
        page: 1,
      },
      tempFile: "", //文件
      titleValue: '',
      schoolList: [],
      gradeDataList: [],
      classList: [],
      schoolListTopId: '',
      gradeDataListTopId: '',
      classListTopId: '',
      schoolListTop: [],
      gradeDataListTop: [],
      classListTop: [],
      twigMax: 0,
      twigMin: 0,
      school_loading: false,
      grade_loading: false,
      class_loading: false,
      leaveType: 3,
      // 状态列表
      statusList: [
        { key: 3, label: '全部' },
        { key: 0, label: '待审批' },
        { key: 1, label: '已同意' },
        { key: 2, label: '已拒绝' },
      ]
    };

  },
  created() {
    this.schoolOrUserManagementleavePage()
  },
  mounted() {
    this.schoolPost(false)
  },
  methods: {
    handleTabChange(key) {
      this.leaveType = key;
      // 这里可以添加切换后的业务逻辑，比如请求对应状态的数据
      console.log('当前选中的状态：', key);
      this.schoolOrUserManagementleavePage()
      // 示例：可调用接口获取对应状态的审批数据
      // this.getApprovalList(key);
    },
    closeClick() {
      this.ShowPeople = false

    },
    filtrateclick() {
      const params = {
        classId: this.classListTopId, // 班级
        gradeId: this.gradeDataListTopId, // 年级
        schoolId: this.schoolListTopId, // 学校
        stuName: this.Dform.studentName,
        stuNum: this.Dform.studentNo,
        page: this.pageInfo.page,
        pageSize: '9999',
        imei: this.Dform.imei,
        status: this.leaveType,
        startDate: this.Dform.startTime, //开始时间
        endDate: this.Dform.endTime, //结束时间
        loginId: JSON.parse(localStorage.getItem('user')).id,
      }
      if (!this.Dform.startTime) {
        delete params.startDate
      }
      if (!this.Dform.endTime) {
        delete params.endDate
      }
      exportLeaveData(params).then((res) => {
        this.handleExport(res.data, '请假数据筛选导出.xls')
      }).catch((err) => {
        // ElMessage.error("导出数据报表失败")
        ElMessage.error(err.response.data.msg)

      })
    },
    classPost() {
      let params = {
        page: '1',
        pageSize: '999',
      }
      this.class_loading = true;
      findClassList(params, this.gradeDataListTopId).then((res) => {
        this.classListTop = res.data.data;
        this.class_loading = false;
      }).catch((err) => {
        console.log(err);
        this.class_loading = false;
      })
    },

    gradePost() {
      let params = {
        page: '1',
        pageSize: '999',
      }
      this.grade_loading = true;
      gradeList(params, this.schoolListTopId).then((res) => {
        console.log(res, '年级列表');
        this.grade_loading = false;
        this.gradeDataListTop = res.data.data;
      }).catch((err) => {
        this.grade_loading = false;
        console.log(err);
      })
    },

    schoolPost(schooName) {
      if (this.schoolList.length > 0) {
        return;
      }

      let params = JSON.parse(localStorage.getItem('user')).id;
      if (schooName) {
        this.school_loading = true
      }
      schoolList(params).then((res) => {
        console.log(res, '学校列表');
        this.schoolList = res.data.data;
        this.schoolListTop = res.data.data;
        this.school_loading = false;
      }).catch((err) => {
        console.log(err);
        this.school_loading = false;
      })
    },
    schoolClickTop() {
      this.gradeDataListTopId = ''
      this.classListTopId = ''
      this.gradeDataListTop = []
      this.classListTop = []
      this.schoolOrUserManagementleavePage()
    },

    gradeClickTop() {
      this.classListTopId = ''
      this.classListTop = []
      this.schoolOrUserManagementleavePage()
    },

    classClickTop(){
      this.schoolOrUserManagementleavePage()
    },

    leaveTypeclick(){
      this.schoolOrUserManagementleavePage()
    },

    schoolOrUserManagementleavePage(){
      const params = {
        classId: this.classListTopId, // 班级
        endDate: this.Dform.endTime,//结束时间
        gradeId: this.gradeDataListTopId, // 年级
        imei: this.Dform.imei,
        schoolId: this.schoolListTopId, // 学校
        stuName: this.Dform.studentName,
        stuNum: this.Dform.studentNo,
        startDate: this.Dform.startTime, //开始时间
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        status:this.leaveType,
        loginId: JSON.parse(localStorage.getItem('user')).id,
      }
      if (!this.Dform.startTime && !this.Dform.endTime) {
        delete params.startDate;
        delete params.endDate;
      }
      if (!this.Dform.startTime && this.Dform.endTime) {
        ElMessage.error('请选择开始时间或删除结束时间');
        return;
      }
      if (this.Dform.startTime && !this.Dform.endTime) {
        ElMessage.error('请选择结束时间或删除开始时间');
        return;
      }
      schoolOrUserManagementleavePage(params).then((res) => {
        // console.log( res.data.data.list,'请假管理成功');
        this.tableData = res.data.data.list
        this.total = res.data.data.total
        this.loading = false
        let str = 0
        if (res.data.data.list.length < 10) {
          str = 10 - res.data.data.list.length
        }
        console.log(this.pageInfo.pageSize * this.pageInfo.page - 9, '--->', this.pageInfo.pageSize *
            this.pageInfo.page - str);
        this.twigMin = this.pageInfo.pageSize * this.pageInfo.page - 9
        this.twigMax = this.pageInfo.pageSize * this.pageInfo.page - str

      }).catch((err) => {
        console.log(err, '请假管理失败');

      })
    },
    entrylogClick() {
      this.schoolOrUserManagementleavePage()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageInfo.page = val
      this.schoolOrUserManagementleavePage()
    },
    handleExport(data, name) {
      // 动态创建iframe下载文件
      let fileName = name;
      if (!data) {
        return;
      }
      let blob = new Blob([data], {
        type: "application/octet-stream"
      });
      console.log(blob);
      if ("download" in document.createElement("a")) {
        // 不是IE浏览器
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 下载完成移除元素
        window.URL.revokeObjectURL(url); // 释放掉blob对象
      } else {
        // IE 10+
        window.navigator.msSaveBlob(blob, fileName);
      }
    },

  },
};
</script>

<style scoped lang="scss">
.status-tabs {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e7eb; /* 底部边框，可选 */
  padding: 0 8px;
}

/* 单个标签样式 */
.status-tab-item {
  padding: 8px 16px;
  margin: 0 4px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  border-radius: 4px 4px 0 0; /* 顶部圆角 */
  transition: all 0.2s ease;
  border: 1px solid transparent; /* 透明边框，避免切换时布局抖动 */
  border-bottom: none; /* 隐藏底部边框 */
}

/* 非激活态 hover 效果 */
.status-tab-item:not(.active):hover {
  color: #1677ff;
  background-color: #f5f8ff;
}

/* 激活态样式 */
.status-tab-item.active {
  color: #1677ff;
  background-color: #fff;
  border-color: #1677ff;
  font-weight: 500;
  box-shadow: 0 -2px 0 0 #1677ff inset; /* 底部蓝色下划线 */
}



.loading_view {
  position: absolute;
  padding: 5px;
  background-color: rgba(0, 0, 0, 0.8);
  width: 100%;
  color: white;
  text-align: center;
  border-radius: 5px;
}

.fuzzy-matching-box {
  padding-top: 20px;
  // overflow: hidden;
  // overflow: auto;
  width: 100%;
  height: 96%;
  background-color: #fff;
  border-radius: 8px;

  .query-button {
    margin: 2px;
    padding: 0px;
    font-size: 15px;
    font-weight: 700;
  }

  .title-top {
    padding: 20px 20px;
  }

  .fuzzy-matching-top {
    height: 130px;
    background-color: #fff;
    border-radius: 8px;

    .top-first-line {
      :deep() {
        .el-form-item--small .el-form-item__label {
          // background-color: red;
          font-size: 16px;
        }

        .el-select--small {
          width: 100%
        }

        .el-form-item--small .el-form-item__label {
          width: 110px;
          text-align: right;
          height: 35px;
          line-height: 35px;
          font-weight: 700;
        }

        .el-input {
          width: 100%;
          height: 35px;
        }

        .el-select--small .el-select__wrapper {
          height: 35px !important;
        }
      }
    }

    .the-second-line {
      margin-top: 15px;
      position: relative;

      .query-button {
        position: absolute;
        right: 375px;
        padding: 16px 24px;
        // top: 50%;
        // transform: translate(0,-50%);
        // background-color: #1677FF;
      }

      .right {
        right: 550px;
      }

    }

    :deep() {
      .el-range-editor--small.el-input__wrapper {
        height: 35px;
        line-height: 35px;
      }
    }

  }

  .fuzzy-matching-content {
    height: 20px;
    line-height: 20px;
    margin-bottom: 10px;

    :deep() {
      .el-button {
        margin-left: 50px;
        font-size: 16px;

      }
    }
  }

  .block {
    display: flex;
    justify-content: center;
    text-align: center;
    font-size: 15px;
    margin-top: 10px;

    .sorter {
      margin-left: 50px;
    }

    .total {
      padding-top: 5px;
      margin-left: 800px;

    }

    .texttiao {
      color: #459FFC;

    }
  }

  .fuzzy-matching-bottom {
    // position: absolute;
    padding: 20px;

    .textButton {
      // background-color: pink;
      font-size: 14px;
      font-weight: 700;
    }

    .red_bottom {
      color: red;
    }

    .green_bottom {
      color: #1BC896;
    }

    .tubiao {
      width: 12px;
    }

    .shanchuBtn {
      margin: 2px;
      padding: 0px;
      font-size: 15px;
      font-weight: 700;
      color: red;
    }

    :deep() {
      .el-table th.el-table__cell>.cell {
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 16px;
      }

      .el-table td.el-table__cell div {
        text-align: center;
        height: 40px;
        line-height: 40px;
        border: 0;
        font-size: 16px;
        color: black;
      }

      .el-table:not(.el-table--border) .el-table__cell {
        // border: 0;
      }

      .el-button--small {
        margin: 0;
        padding: 0;
      }
    }

    .block-fenye {
      margin-left: 1000px;
      margin-top: 15px;
    }
  }

  .upload-box {
    margin-top: 15px;
    // line-height: 25px;

    :deep() {
      .el-select .el-input {
        height: 25px;
        margin-top: 0;
      }

      .el-form-item {
        margin-bottom: 0px !important;


      }

      .el-form-item__label {
        margin-left: 50px !important;

      }

    }

    .upload-lef {
      margin-left: 50px;
      font-size: 14px;

      .upload-title {}
    }

    .el-table tr {
      font-size: 20px;
    }

    :deep() {
      .el-button--small {
        height: 30px;
        margin-left: 100px;
        padding: 0px 25px;
      }

      .el-table--enable-row-transition .el-table__body td.el-table__cell {
        font-size: 40px;
      }

      // .el-form-item--small .el-form-item__content {
      //     height: 40px;
      //     line-height: 40px;
      // }
      .el-select .el-input__inner {
        height: 35px;
      }

      .el-form-item--small .el-form-item__label {
        margin-left: 20px;
        line-height: 28px;
      }

      .el-upload-list {
        // dis
        font-size: 80px;
      }

      .el-select--small .el-select__wrapper {
        width: 200px !important;
        // height: 35px !important;
      }
    }
  }
}
</style>